import { Component, OnInit, ViewChild } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Router } from '@angular/router'

import { EventsEmitterService } from '../../services/events-emitter.service'
import { EventsService } from '../../services/events.service'
import { MessagesDelegate } from '../../services/messages-delegate.service'
import { UsersService } from '../../services/users.service'

import { Event } from '../../models/event.model'

@Component({
  selector: 'ld-event',
  template: require('./event.component.html'),
  styles: [require('./event.component.css')]
})
export class EventComponent implements OnInit {

  @ViewChild('eventFormComponent') eventFormComponent
  private resourceId: string
  private editing$
  private event = new Event()

  constructor (
    private eventsEmitterService: EventsEmitterService,
    private route: ActivatedRoute,
    private eventsService: EventsService,
    private messagesDelegate: MessagesDelegate,
    private router: Router,
    private usersService: UsersService) {
    this.editing$ = this.eventsEmitterService.listen('editing')
  }

  async ngOnInit () {
    this.resourceId = this.route.snapshot.params.id
    const currentUser = this.usersService.currentUser

    try {
      this.event = await this.eventsService.getById(this.resourceId)
    } catch (err) {
      this.messagesDelegate.add(err.status === 404 ? 'APP.EVENT.NOT_FOUND' : err.message, true)
      this.router.navigate(['/home'])
      return
    }

    if (currentUser.isAdmin() || currentUser.id === this.event.author.id) {
      this.eventsEmitterService.emit('showAdminMenu', true)
    }
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/event/event.component.ts